"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const PermissionsContext_1 = require("./PermissionsContext");
function usePermissions() {
    const permissions = react_1.useContext(PermissionsContext_1.PermissionsContext);
    return permissions;
}
exports.usePermissions = usePermissions;
//# sourceMappingURL=usePermissions.js.map